// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1743":"d77db50a","2440":"766490aa","4499":"d46a2237"}[chunkId] + ".chunk.css";
};